import { render, staticRenderFns } from "./BBS902P01.vue?vue&type=template&id=2533209e&"
import script from "./BBS902P01.vue?vue&type=script&lang=js&"
export * from "./BBS902P01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports